export const NEC_1099_SUMMARY_SLUG = "1099";
export const NEC_1099_SUMMARY_DISPUTE_SLUG = `dispute`;
export const NEC_1099_PAYMENTS_SLUG = "payments";
